﻿import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import { config } from '../../assets/config';
import {Question} from '../_models/question';

@Injectable()
export class FAQService {
    constructor(private http: HttpClient) {}

    getAll() {
        return this.http.get<Question[]>(`${config.apiUrl}/questions`);
    }

    getById(id: number) {
        return this.http.get(`${config.apiUrl}/questions/` + id);
    }
}
